import { config } from '../config';
import { getHeaders } from './getHeaders';

export const deleteLostOpportunity = (
  token: string,
  rooferId: string,
  opportunityId: string,
) =>
  fetch(
    `${config.classificationUrl}/api/v1/roofer/${rooferId}/project/${opportunityId}/deletelost`,
    {
      method: 'PUT',
      headers: getHeaders(token),
    },
  );
